define('bindingHandlers/scrollSnap',[
    'jquery',
    'lib/knockout',
    //require the plugin
    'lib/jqueryScrollsnap'
], function ($, ko) {
    'use strict';

    var SCROLL_SNAP_SELECTOR = "[data-scroll-snap]";

    /*
        A binding handler that exposes the jqueryScrollsnap plugin functionality;

        Usage:
            binding handler should be attached to parent, with data-scroll-snap
        Example:
            <div data-bind="scrollSnap: {}">
                <div data-scroll-snap></div>
                <div data-scroll-snap></div>
            </div>

        Options: none yet, can be added as needed
    */



    ko.bindingHandlers.scrollSnap = {
        init: function (element) {
            $(element).scrollsnap({
                snaps: SCROLL_SNAP_SELECTOR,
                proximity: 70,
                latency: 425,
                duration: 50
            });
        }
    };
});
